import { z } from 'zod';
import { configurationParameterSchema, fullParameterDataSchema, parameterDataSchema, parameterSelectedConfigurationSchema, selectedConfigurationParameterSchema } from './parameter';
import { whereSchema } from './question_conditional';

export const CONFIG_PARAMETER_KEYS = ['crm', 'survey', 'project', 'question'] as const;



function createBaseConfigurationSchema<T extends z.ZodTypeAny>(parameterSchema: T) {
    return z.object({
        parameter: z.record(
            z.enum(CONFIG_PARAMETER_KEYS), // Keys are from the enum
            z.array(parameterSchema).optional() // Values are optional arrays of the parameter type
        ).optional(),
    });
}

export const configurationSchema = createBaseConfigurationSchema(configurationParameterSchema);
export const matchedConfigurationSelectedConfigurationSchema = createBaseConfigurationSchema(selectedConfigurationParameterSchema);

export const selectedConfigurationSchema = z.object({
    parameter: parameterSelectedConfigurationSchema.optional(),
})

export const questionConditionalsSchema = z.object({
    enabled: z.boolean().optional(),
    where: whereSchema.optional(),
});

export const questionSelectedConfigurationSchema = selectedConfigurationSchema.extend({
    conditionals: questionConditionalsSchema.optional(),
});
export const configurationDataSchema = z.object({
    parameter: z.record(
        z.enum(CONFIG_PARAMETER_KEYS),
        z.record(z.string(), z.array(parameterDataSchema))
    ),
})
export const fullConfigurationSchema = createBaseConfigurationSchema(fullParameterDataSchema);